import { Table } from 'antd';
import { TableRowSelection } from 'antd/lib/table/interface';
import React, { useContext, useEffect, useState } from 'react';
import { buildColumn, ColumnsProps, ScrollType } from '../../../../../../../Helper';
import { DataTableType } from '../../../../../../../model/DeviceAdminModel';
import { SearchColumn } from '../../../../../../common';
import { ControllersSelected, setSelectedReadersGridInfo, StoreContext } from '../../context';
import styles from './infoGrid.module.scss';

type Props = {
	onClickRow: (reader: ControllersSelected) => void;
};

type DataType = DataTableType<ControllersSelected & { index: number }>;

//Avoid creating object style inline, since increases reconciliations
const scroll: ScrollType = { y: 210 };

const InfoGrid: React.FC<Props> = ({ onClickRow }) => {
	const {
		readerState: { readersSelected, readersInfoGridSelected, timeZoneSelected },
		dispatcher,
	} = useContext(StoreContext);

	const [selectedRowKeys, setSelectedRowKeys] = useState([] as React.Key[]);

	//reset state on items selected has been removed from InfoGrid
	useEffect(() => {
		if (readersInfoGridSelected.length === 0) {
			setSelectedRowKeys([]);
		}
	}, [JSON.stringify(readersInfoGridSelected)]);

	//keep until any bug has been found
	// const handleCheck = (checked: boolean, readerId: number) => {
	// 	if (checked) {
	// 		dispatcher(setSelectedReadersGridInfo([...readersInfoGridSelected, readerId]));
	// 	} else {
	// 		const cloneState = readersInfoGridSelected;
	// 		const index = cloneState.findIndex(x => x === readerId);
	// 		if (~index) {
	// 			cloneState.splice(index, 1);
	// 			dispatcher(setSelectedReadersGridInfo([...cloneState]));
	// 		}
	// 	}
	// };

	const handleSelectAll = (checked: boolean) => {
		if (checked) {
			dispatcher(setSelectedReadersGridInfo([...readersSelected.filter(x => !x.isInUse).map(x => x.ReaderId)]));
		} else {
			dispatcher(setSelectedReadersGridInfo([]));
		}
	};

	const handleClickRow = (door: DataType) => {
		let selectedRows: React.Key[] = [];
		let doorSelected: number[] = [];
		if (selectedRowKeys.find(x => x === door.key)) {
			selectedRows = selectedRowKeys.filter(doorSelected => doorSelected !== door.key);
			doorSelected = readersInfoGridSelected.filter(doorSelected => doorSelected !== door.ReaderId);
		} else {
			selectedRows = [...selectedRowKeys, door.key];

			doorSelected = [...readersInfoGridSelected, door.ReaderId];
		}
		setSelectedRowKeys(selectedRows);
		dispatcher(setSelectedReadersGridInfo(doorSelected));
	};

	// rowSelection object indicates the need for row selection
	const rowSelection: TableRowSelection<DataType> = {
		selectedRowKeys,
		onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
			setSelectedRowKeys(selectedRowKeys);
			dispatcher(setSelectedReadersGridInfo(selectedRows.map(x => x.ReaderId)));
		},
		// onSelect: (record: DataType, selected: boolean) => {
		// 	handleCheck(selected, record.ReaderId);
		// },
		onSelectAll: (selected: boolean) => {
			handleSelectAll(selected);
		},
		getCheckboxProps: (record: DataType) => ({
			disabled: record.isInUse,
			id: `doorGroupModalDoorsSavedCheckbox-${record.index.toString()}`,
		}),
	};

	const createData = (data: ControllersSelected[]) =>
		data.map<DataType>((dataItem: ControllersSelected, index: number) => ({
			key: dataItem.ReaderId,
			index,
			...dataItem,
		}));

	const columns: ColumnsProps<DataType>[] = [
		{
			...buildColumn(_('Address'), 'Address', '210px', 'start'),
			sorter: (a, b) => a.Address.localeCompare(b.Address),
		},
		{
			...buildColumn(_('Readers'), 'ReaderName', 'auto', 'start'),
			sorter: (a, b) => a.ReaderName.localeCompare(b.ReaderName),
			...SearchColumn({ maxLength: 32, dataIndex: 'ReaderName', reset: false, label: _('ReaderName') }),
		},
		{
			...buildColumn(_('TimeZone'), 'Name', '180px', 'start'),
			sorter: (a, b) => a.Name.localeCompare(b.Name),
			onCell: record => ({ id: `doorGroupSavedDoorsTableTimeZone-${record.index}` }),
		},
	];

	const readersSelectedDataTable = createData(readersSelected);

	return (
		<div id='doorGroupSelectedDoorsContainer' className={styles.container}>
			<Table
				id='doorGroupSavedDoorsTable'
				rowSelection={{
					...rowSelection,
				}}
				onRow={(record: DataType) => ({
					onClick: () => handleClickRow(record),
				})}
				size='small'
				columns={columns}
				dataSource={readersSelectedDataTable}
				scroll={scroll}
				className={styles.statusWidgetTable}
				pagination={false}
				onHeaderRow={() => ({ id: 'doorGroupSavedDoorsTableHeader' })}
				getPopupContainer={() => document.getElementById('doorGroupSavedDoorsTableHeader')}
			/>
		</div>
	);
};

export { InfoGrid };
